<template>
  <div>
    <p v-if="isLoading">Loading</p>
    <div v-else-if="data" class="columns is-variable is-flex-direction-column">
      <div class="column is-12">
        <div class="is-flex flex-sm-column">
          <div class="card card-wrapper-costum mr-4 mr-sm-0 mb-sm-2 mb-0 flex-1 p-4">
            <p class="text-title averta-bold">Detail Penawaran</p>
            <div class="mb-3">
              <p class="label-14 color-gray">ID</p>
              <p class="averta-bold">{{ detailOffering.id }}</p>
            </div>
            <div class="mb-3">
              <p class="label-14 color-gray">Tanggal Pembuatan Penawaran</p>
              <p class="averta-bold">
                {{ formatDate(detailOffering && detailOffering.created_at) }}
              </p>
            </div>
            <div class="mb-3">
              <p class="label-14 color-gray">PIC - No. Telp</p>
              <p class="averta-bold">
                {{
                  detailOffering && isPurchasing ? detailOffering.pic_name : detailOffering.pic.name
                }}
                -
                <span class="color-blue">{{
                  detailOffering && isPurchasing
                    ? detailOffering.pic_phone
                    : detailOffering.pic.phone
                }}</span>
              </p>
            </div>
          </div>
          <div class="card card-wrapper-costum flex-1 p-4">
            <p class="text-title averta-bold">Detail Proyek</p>
            <div class="mb-3">
              <p class="label-14 color-gray">Alamat Pengerjaan</p>
              <p class="averta-bold text-red">{{ detailProject && detailProject.address }}</p>
            </div>
            <div class="mb-3">
              <p class="label-14 color-gray">Catatan Perbaikan</p>
              <p class="averta-bold">{{ (detailProject && detailProject.note) || '-' }}</p>
            </div>
            <div v-if="isPurchasing" class="mb-3">
              <p class="label-14 color-gray">Konsultan Pengawas</p>
              <p class="averta-bold">
                {{ (detailProject && detailProject.consultan_name) || '-' }}
                <span class="color-blue">{{ detailProject && detailProject.consultan_phone }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Detail Survey -->
      <div v-if="detailSurvey" class="column is-12 pt-1">
        <div class="card card-wrapper-costum p-4">
          <p class="averta-bold is-size-5 mb-4">Detail Proyek</p>
          <div class="wrapper-tanggal-survey is-flex is-justify-content-space-between mb-3">
            <div
              class="is-flex is-align-items-center flex-sm-column align-items-sm-start flex-sm-row"
            >
              <CalendarIcon class="mr-3" />
              <div class="is-flex is-flex-direction-column">
                <p class="color-blue" style="font-size: 12px">Tanggal Survey</p>
                <p class="averta-bold">{{ formatDate(detailSurvey.date) }}</p>
              </div>
            </div>
            <div class="wrapper-skill">
              <div
                class="is-flex is-align-items-center averta-bold is-justify-content-end justify-content-sm-start"
              >
                <img
                  v-if="detailSurvey.skill_image"
                  :src="detailSurvey.skill_image"
                  alt="skill_image"
                  class="skill-image mr-3"
                />
                <p>{{ detailSurvey.skill_name ? detailSurvey.skill_name : '-' }}</p>
              </div>
            </div>
          </div>
          <div
            class="wrapper-tukang"
            v-if="detailSurvey.status !== 'Survey Dibatalkan'"
          >
            <div
              class="is-flex is-justify-content-space-between is-align-items-center wrapper-detail-tukang flex-sm-column align-items-sm-start c-w-100"
            >
              <div
                class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center c-w-100"
              >
                <div
                  class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center"
                >
                  <div
                    v-if="detailSurvey.worker_image && detailSurvey.worker_image !== '-'"
                    class="mr-3 img-photo-tukang"
                  >
                    <img :src="detailSurvey.worker_image" alt="worker_image" class="w-100" />
                  </div>
                  <div>
                    <p
                      class="averta-bold"
                      :class="{ 'averta-bold-italic': detailSurvey.worker_name === '-' }"
                    >
                      {{
                        detailSurvey.worker_name && detailSurvey.worker_name !== '-'
                          ? detailSurvey.worker_name
                          : 'Belum diassign'
                      }}
                    </p>
                    <p v-if="detailSurvey.worker_id">
                      {{ detailSurvey.worker_id ? 'ID' + detailSurvey.worker_id : '-' }}
                    </p>
                  </div>
                </div>
                <div
                  class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center gap-7"
                >
                  <div
                    v-if="detailSurvey.worker_id"
                    class="is-flex is-flex-direction-row is-justify-content-center is-align-items-center"
                  >
                    <p class="averta-black">Absensi :</p>
                  </div>
                  <div
                    v-if="detailSurvey.worker_id"
                    class="is-flex is-flex-direction-row is-justify-content-flex-end is-align-items-center gap-4"
                  >
                    <div
                      class="is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-end"
                    >
                      <p
                        class="averta-bold color-red"
                        :class="{ 'averta-bold-italic': detailSurvey.worker_name === '-' }"
                      >
                        Hadir
                      </p>
                      <p
                        v-if="detailSurvey.worker_id"
                        :class="{
                          'averta-bold': isValidDate(detailSurvey.attendance_start_date),
                          'color-black averta-regular-italic': !isValidDate(
                            detailSurvey.attendance_start_date
                          )
                        }"
                      >
                        {{
                          detailSurvey.attendance_start_date
                            ? absen(detailSurvey.attendance_start_date)
                            : 'Belum Absen'
                        }}
                      </p>
                      <p
                        :style="{ display: detailSurvey.attendance_start_date ? 'flex' : 'none' }"
                        class="averta-regular color-black"
                      >
                        {{ formatDate(detailSurvey.attendance_start_date) }}
                      </p>
                    </div>
                    <div
                      class="is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-end"
                    >
                      <div
                        v-if="detailSurvey.worker_id"
                        class="card-photo-before-after"
                        :class="{ 'cursor-pointer': showImageBefore.filename !== '-' }"
                      >
                        <EmptyImageIcon
                          v-if="showImageBefore && showImageBefore.filename === '-'"
                          size="100%"
                        />
                        <img
                          v-else
                          :src="showImageBefore && showImageBefore.filename"
                          alt="worker_image"
                          @click="
                            handlePreviewImage(
                              detailSurvey.images.filter((image) => image.name === 'Absensi Hadir' || image.name === 'Absensi Pulang'),
                              'photoSurvey'
                            )
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="detailSurvey.worker_id"
                    class="divider-vertical-line-1"
                    style="min-height: 35px"
                  ></div>
                  <div
                    v-if="detailSurvey.worker_id"
                    class="is-flex is-flex-direction-row is-justify-content-flex-end is-align-items-center gap-4"
                  >
                    <div
                      class="is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-end"
                    >
                      <p
                        class="averta-bold color-red"
                        :class="{ 'averta-bold-italic': detailSurvey.worker_name === '-' }"
                      >
                        Pulang
                      </p>
                      <p
                        v-if="detailSurvey.worker_id"
                        :class="{
                          'averta-bold': isValidDate(detailSurvey.attendance_end_date),
                          'color-black averta-regular-italic': !isValidDate(
                            detailSurvey.attendance_end_date
                          )
                        }"
                      >
                        {{
                          detailSurvey.attendance_end_date
                            ? absen(detailSurvey.attendance_end_date)
                            : 'Belum Absen'
                        }}
                      </p>
                      <p
                        :style="{ display: detailSurvey.attendance_end_date ? 'flex' : 'none' }"
                        class="averta-regular color-black"
                      >
                        {{ formatDate(detailSurvey.attendance_end_date) }}
                      </p>
                    </div>
                    <div
                      v-if="detailSurvey.worker_id"
                      class="is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-end"
                    >
                      <div
                        class="card-photo-before-after"
                        :class="{ 'cursor-pointer': showImageAfter.filename !== '-' }"
                      >
                        <EmptyImageIcon
                          v-if="showImageAfter && showImageAfter.filename === '-'"
                          size="100%"
                        />
                        <img
                          v-else
                          :src="showImageAfter && showImageAfter.filename"
                          alt="worker_image"
                          @click="
                            handlePreviewImage(
                              detailSurvey.images.filter(
                                (image) => image.name === 'Absensi Pulang' || image.name === 'Absensi Hadir'
                              ),
                              'photoSurvey'
                            )
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="divider-dashed-line-1" v-if="detailSurvey.worker_id"></div>
            <div
              class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center c-w-100"
              v-if="detailSurvey.worker_id"
            >
              <div
                class="is-flex is-flex-direction-column is-justify-content-flex-start is-align-items-flex-start c-w-100"
              >
                <p class="averta-bold">Catatan dari konsultan</p>
                <p class="white-space-preline">
                  {{ detailSurvey.note !== 'null' && detailSurvey.note ? detailSurvey.note : '-' }}
                </p>
                <p
                  class="white-space-preline mt-2 averta-regular-italic"
                  :style="{ display: detailSurvey.note_updated_at === null ? 'none' : 'flex' }"
                >
                  Diperbaharui oleh:
                  {{ detailSurvey.note_updated_by }}
                  ({{ moment(detailSurvey.note_updated_at).format('dddd, DD MMMM YYYY - HH:mm') }})
                </p>
              </div>
              <div
                class="is-flex is-flex-direction-row is-justify-content-flex-end is-align-items-flex-start c-w-100"
                v-if="
                  (detailSurvey.status === 'Survey Berlangsung' ||
                    detailSurvey.status === 'Survey Diproses' ||
                    detailSurvey.status === 'Proses Business Support' ||
                    detailSurvey.status === 'Survey Selesai' ||
                    detailSurvey.status === 'Proses Site Manager' ||
                    detailSurvey.status === 'Proses Purchasing') &&
                  detailSurvey.worker_id
                "
              ></div>
            </div>
          </div>

          <p class="averta-bold mb-3 mt-4">Foto Kehadiran Survey</p>
          <p v-if="!detailSurvey.images" class="is-italic has-text-grey">Empty</p>
          <div
            v-if="detailSurvey.images.length > 0"
            class="wrapper-file-photo is-flex is-align-items-flex-start is-justify-content-flex-start gap-10"
          >
            <div
              class="wrapper-file flex-shrink-0 word-wrap-break"
              v-for="(dataImage, indexImage) in detailSurvey.images.filter(
                (image) => image.name !== 'Absensi Hadir' && image.name !== 'Absensi Pulang'
              )"
              :key="dataImage.id"
              style="min-width: auto"
            >
              <div
                :class="
                  detailSurvey.images.length === 6
                    ? 'image-survey'
                    : detailSurvey.images.length === 7
                    ? 'image-survey-5'
                    : 'image-survey-6'
                "
                v-if="dataImage && dataImage.filename === '-'"
                class="image-survey mb-2"
              >
                <EmptyImageIcon size="100%" />
              </div>
              <img
                v-else
                class="image-survey mb-2 is-clickable"
                :src="dataImage && dataImage.filename"
                :alt="dataImage && dataImage.name"
                :class="
                  detailSurvey.images.length === 6
                    ? 'image-survey'
                    : detailSurvey.images.length === 7
                    ? 'image-survey-5'
                    : 'image-survey-6'
                "
                @click="
                  handlePreviewImage(
                    detailSurvey.images.filter(
                      (image) =>
                        image.name !== 'Absensi Hadir' &&
                        image.name !== 'Absensi Pulang' &&
                        image.filename !== '-'
                    ),
                    'photoSurvey',
                    indexImage
                  )
                "
              />
              <b-tooltip
                :position="
                  indexImage > 4
                    ? indexImage + 1 >= detailSurvey.images.length - 3
                      ? 'is-left'
                      : 'is-right'
                    : 'is-right'
                "
                type="is-dark"
                :triggers="['hover']"
                :auto-close="true"
                append-to-body
              >
                <template v-slot:content>
                  <div style="max-width: 300px" class="word-wrap-break">
                    <p class="white-space-nowrap">{{ dataImage.name }}</p>
                  </div>
                </template>
                <p
                  class="averta-bold image-name m-0 p-0"
                  :class="
                    detailSurvey.images.length === 6
                      ? 'image-name'
                      : detailSurvey.images.length === 7
                      ? 'image-name image-name-5'
                      : 'image-name image-name-6'
                  "
                >
                  {{ dataImage.name }}
                </p>
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>

      <ModalPreviewImage
        :indexImg="indexImg"
        :isActive="previewImage"
        :isOneImage="true"
        :dataImage="imagePreview"
        @closeModal="closePreviewImage()"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'TabDetailProyek',
  props: ['data', 'surveyId', 'isBS', 'isPurchasing'],
  data () {
    return {
      isLoading: true,
      detailSurvey: null,
      detailOffering: null,
      detailProject: null,

      previewImage: false,
      imagePreview: null,
      indexImg: 0,
      moment: moment
    }
  },
  components: {
    CalendarIcon: () => import('@/components/icons/CalendarIcon'),
    EmptyImageIcon: () => import('@/components/icons/EmptyImageIcon'),
    ModalPreviewImage: () => import('@/components/modal/ModalPreviewImage')
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl'
    }),
    showImageBefore () {
      return this.detailSurvey.images.find((image) => image.name === 'Absensi Hadir')
    },
    showImageAfter () {
      return this.detailSurvey.images.find((image) => image.name === 'Absensi Pulang')
    }
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return '-'
      }

      return moment(date).format('dddd, DD MMMM YYYY')
    },
    formatThousand (x) {
      if (!x && x !== 0) {
        return '-'
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    absen (date) {
      const varDate = moment(date)
      if (varDate.isValid() && date) {
        return moment.utc(date).format('HH:mm')
      }
      return 'Belum Absen'
    },
    isValidDate (date) {
      if (moment(date).isValid() && date) {
        return true
      }
      return false
    },
    handlePreviewImage (data, type, index) {
      this.indexImg = index
      if (type === 'photoSurvey') {
        this.imagePreview = data.map((item) => {
          return item.filename
        })
      } else {
        if (data && data !== '-') {
          this.imagePreview = data
        }
      }

      this.previewImage = true
    },
    closePreviewImage () {
      this.imagePreview = null
      this.previewImage = false
    },
    loadData () {
      this.isLoading = true
      if (this.data) {
        this.detailSurvey = this.data.survey || this.data.detail_survey
        this.detailOffering = this.data.offering || this.data.detail_offering
        this.detailProject = this.data.project || this.data.detail_project
      }
      this.isLoading = false
    }
  },
  mounted () {
    this.loadData()
  },
  watch: {
    data () {
      this.loadData()
    }
  }
}
</script>

<style scoped>
.w-100 {
  width: 100%;
}

.color-blue {
  color: #3185fc;
}

.flex-1 {
  flex: 1;
}

.flex-half {
  flex: 0.5;
}

.label {
  color: #868686;
}

.text-red {
  background: linear-gradient(116.12deg, #d9272d 16.15%, #eb4600 83.24%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.strikethrough {
  text-decoration: line-through;
  color: #eb4600;
}

.text-title {
  font-size: 20px;
  margin-bottom: 1rem;
}

.detail-material-wrapper {
  background: #fafafa;
  border-radius: 20px;
  max-height: 30em;
  overflow-y: auto;
}

.material-wrapper {
  background: #fff;
  border-radius: 20px;
}

.fs-12 {
  font-size: 12px;
}

.btn-primary {
  background: linear-gradient(116.12deg, #d9272d 16.15%, #eb4600 83.24%) !important;
  border-radius: 100px;
}

.btn-disabled {
  background: #9a9a9a;
  border-radius: 100px;
}

.material-photo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 57px;
}

.material-photo-wrapper img {
  width: 100%;
}

.header-modal {
  background: #911a1e;
  padding: 24px;
  color: white;
  border-radius: 12px 12px 0px 0px;
}

.body-modal {
  background: white;
  padding: 12px 24px;
  border-radius: 0px 0px 12px 12px;
}

.icon-bag {
  width: 20px;
}

.wrapper-detail {
  background: #fafafa;
  border-radius: 20px;
}

.wrapper-pembulatan {
  background: linear-gradient(90deg, #fffff7 0%, #fff5ea 100%);
  border-radius: 8px;
}

.skill-image {
  width: 30px;
  object-fit: cover;
}

.material-image {
  width: 50px;
  object-fit: cover;
}

.divider {
  background: #e1e1e1;
  border: 1px solid #e1e1e1;
  margin-bottom: 1rem;
}

.wrapper-tukang {
  background: #f8f8f8;
  padding: 14px;
  border-radius: 10px;
}

.wrapper-file-photo {
  background: #f6f6f6;
  padding: 12px;
  border-radius: 12px;
  height: auto;
  overflow-x: auto;
}

.wrapper-file {
  display: flex;
  flex-direction: column;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0 !important;
  height: auto;
  width: auto;
}

.image-survey {
  width: 150px;
  height: 150px;
  object-fit: cover;
  padding: 0;
  border-radius: 8px;
}

.image-survey-5 {
  width: 125px;
  height: 125px;
  object-fit: cover;
  padding: 0;
  border-radius: 8px;
}

.image-survey-6 {
  width: 70px;
  height: 70px;
  object-fit: cover;
  padding: 0;
  border-radius: 8px;
}

.image-name {
  width: auto;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  text-align: center;
  word-wrap: break-word;
}

.image-name-5 {
  width: 125px !important;
}

.image-name-6 {
  width: 80px !important;
}

.img-photo-tukang {
  width: 36px;
  height: 36px;
}

.img-photo-tukang img {
  border-radius: 100px;
  object-fit: cover;
  width: 36px;
  height: 36px;
}

.card-photo-before-after {
  display: flex;
  flex-direction: column;
  width: 55px;
  min-width: 55px;
  max-width: 55px;
  height: 55px;
  min-height: 55px;
  max-height: 55px;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding: 0;
  margin: 0;
  gap: 20px;
  border-radius: 10px;
  overflow: hidden !important;
}

@media screen and (max-width: 600px) {
  .flex-sm-column {
    flex-direction: column;
  }

  .mb-sm-2 {
    margin-bottom: 1rem !important;
  }

  .mr-sm-0 {
    margin-right: 0 !important;
  }
}
</style>
